import { graphql } from '@gql';

export const OverrideCvss = graphql(`
    mutation OverrideCvss($data: OverrideCVSSInput!) {
        overrideCVSS(input: $data)
    }
`);
